import { Button } from '@growdash/design-system/atoms';
import { RHFMultiSelect } from '@growdash/design-system/molecules';
import { IBrand } from '@utils/interfaces';
import { useForm, useFormContext } from 'react-hook-form';
import { CofundingFilterFormValues } from './co-funding-tab';

interface FilterFormValues {
  channels: IBrand[];
  brands: IBrand[];
  branches: IBrand[];
}

interface CoFundingFiltersProps {
  channels: IBrand[];
  brands: IBrand[];
  branches: IBrand[];
  onFilterChange: (filters: CofundingFilterFormValues) => void;
  defaultValues?: Partial<FilterFormValues>;
}

const CoFundingFilters = ({
  channels,
  brands,
  branches,
  onFilterChange,
  defaultValues
}: CoFundingFiltersProps) => {
  // Use form context if component is wrapped in FormProvider, otherwise create new form
  const formContext = useFormContext();
  const methods = useForm<FilterFormValues>({
    defaultValues: {
      channels: defaultValues?.channels || [],
      brands: defaultValues?.brands || [],
      branches: defaultValues?.branches || []
    }
  });

  const { watch } = formContext || methods;

  const selectedChannels = watch('channels') || [];

  const selectedBrands = watch('brands') || [];

  const selectedBranches = watch('branches') || [];

  const sendFilter = () => {
    onFilterChange({
      channels: selectedChannels,
      brands: selectedBrands,
      branches: selectedBranches
    });
  };

  const clearFilter = () => {
    onFilterChange({
      channels: [],
      brands: [],
      branches: []
    });
  };

  return (
    <div className='flex flex-grow justify-end'>
      <div className='flex h-12 gap-2 flex-wrap items-center justify-end w-70% pt-2 pr-2'>
        <div className='flex-1'>
          <RHFMultiSelect
            maxCount={1}
            popoverAlign='end'
            name='channels'
            placeholder={
              !channels?.length ? 'Channels Loading...' : 'Select Channels'
            }
            className={`${
              !channels?.length ? 'animate-pulse' : 'animate-fade-in'
            }`}
            disabled={!channels?.length}
            options={channels.map(channel => ({
              label: channel.name,
              value: channel.name
            }))}
            maxChips={2}
          />
        </div>
        <div className='flex-1'>
          <RHFMultiSelect
            maxCount={1}
            popoverAlign='end'
            name='brands'
            placeholder='Select Brands'
            options={brands.map(brand => ({
              label: brand.name,
              value: brand.id
            }))}
            maxChips={2}
          />
        </div>
        <div className='flex-1'>
          <RHFMultiSelect
            maxCount={1}
            popoverAlign='end'
            name='branches'
            placeholder='Select Branches'
            options={branches.map(branch => ({
              label: branch.name,
              value: branch.id
            }))}
            maxChips={2}
          />
        </div>
        <Button
          variant='secondary'
          onClick={sendFilter}
          disabled={
            !selectedChannels?.length &&
            !selectedBrands?.length &&
            !selectedBranches?.length
          }
        >
          Apply
        </Button>
        <Button variant='secondary' onClick={clearFilter}>
          Clear
        </Button>
      </div>
    </div>
  );
};

export default CoFundingFilters;
